module.exports = __webpack_public_path__ + "static/rise-8228332517f73405833e5b749da08936.png";